'use client'

import { useEffect } from 'react'

/**
 * Register the logo-cache service worker (`public/sw-logos.js`).
 * Narrow-scope SW — only claims fetches to `/v1/logos/*` URLs. Does not
 * interfere with Next.js's own SSR / app-router fetches.
 *
 * Mounted once at the root layout so the SW registers on first page
 * load of any authenticated session. Re-registrations are cheap (browser
 * no-ops when the bytes haven't changed).
 */
export function LogoSwRegistrar() {
  useEffect(() => {
    if (typeof navigator === 'undefined') return
    if (!('serviceWorker' in navigator)) return
    // Defer registration to idle so it doesn't delay first paint.
    const register = () => {
      navigator.serviceWorker
        .register('/sw-logos.js', { scope: '/' })
        .catch((err) => {
          // Non-fatal — previews fall back to direct-fetch of the BE
          // proxy, which already has its own HTTP cache headers.
          // eslint-disable-next-line no-console
          console.warn('[logo-sw] registration failed:', err)
        })
    }
    if ('requestIdleCallback' in window) {
      ;(window as Window & typeof globalThis).requestIdleCallback(register)
    } else {
      setTimeout(register, 1500)
    }
  }, [])
  return null
}
